// Heron.js - Complete version with rectangle (no rounded corners)

import React from "react";
import Image from "../Asset/Teshome.jpg";
import HeroBg from "../Asset/bg.jpg";

const Heron = () => {
  return (
    <section id="home" className="w-full h-full">
      {/* Card absolutely flush to left - rectangle with no curves */}
      <div
        className="
          relative
          flex flex-col items-center
          justify-start
          w-full
          h-full
          min-h-screen
          bg-cover bg-center
          px-8 pt-12 pb-16
          shadow-2xl
        "
        style={{ backgroundImage: `url(${HeroBg})` }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-slate-900/60" />

        {/* Foreground content */}
        <div className="relative flex flex-col items-center text-center text-white w-full">
          {/* Profile Picture */}
          <div className="mb-6">
            <img
              src={Image}
              alt="Teshome Getaw Ketema"
              className="w-48 h-48 md:w-56 md:h-56 rounded-full object-cover shadow-2xl border-4 border-white"
              style={{
                objectPosition: 'center',
                display: 'block'
              }}
              onError={(e) => {
                console.error('Image failed to load:', e);
                e.target.style.display = 'none';
              }}
            />
          </div>

          <h1 className="text-3xl md:text-4xl font-semibold leading-tight mb-4">
            Teshome Getaw Ketema
          </h1>

          <p className="text-base md:text-lg text-slate-200 mb-2">
            Ph.D. Student, Electrical &amp; Computer Engineering
          </p>

          <p className="text-sm md:text-base text-slate-300 mb-6">
            New York Institute of Technology, Long Island, NY
          </p>

          <button
            onClick={() => window.open("/CV.pdf", "_blank")}
            className="mt-2 bg-transparent border-2 border-white hover:bg-white hover:text-slate-900 px-8 py-2.5 rounded-md text-base font-medium transition-all duration-300"
          >
            Resume
          </button>
        </div>
      </div>
    </section>
  );
};

export default Heron;